import { h, Fragment } from "preact";
import {
  Typography,
  Input,
  Button,
  Upload,
  Form,
  Tooltip,
  Modal,
  Skeleton,
  message,
} from "antd";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "preact/hooks";
import axios from "axios";
import useBlacklists from "./useBlacklists";

export default function BlacklistPage() {
  const { blacklists, fetchBlacklists, deleteBlacklist, isLoading } =
    useBlacklists();
  const [file, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [blacklistName, setBlacklistName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSelectedList, setModalSelectedList] = useState(null);
  const [messageApi, resultMessage] = message.useMessage();

  useEffect(() => {
    fetchBlacklists();
  }, []);

  const openModal = (list_name) => {
    setModalSelectedList(list_name);
    setModalOpen(true);
  };
  const handleDelete = async (list_name) => {
    try {
      await deleteBlacklist(list_name);
      await fetchBlacklists();
      messageApi.open({
        type: "success",
        content: "Blacklist deleted!",
      });
      setModalOpen(false);
    } catch(error){
      messageApi.open({
        type: "erorr",
        content: "Blacklist was not deleted, try again!",
      });
    }
  };

  const fileToBlob = async (file) =>
    new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type });

  const handleUpload = async () => {
    const blobFile = await fileToBlob(file);
    const formData = new FormData();
    formData.set("file", blobFile, "blacklist.csv");
    setUploading(true);
    const path = `/user/kyc/blacklist/${blacklistName}/file`;
    axios
      .post(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        messageApi.open({
          type: "success",
          content: "Uploaded",
        });
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.error_msg || error.response?.data || " ";
        messageApi.open({
          type: "error",
          content: `Not uploaded, ${errorMsg.toLowerCase()}`,
        });
      })
      .finally(() => {
        fetchBlacklists();
        setSelectedFile(null);
        setBlacklistName("");
        setUploading(false);
      });
  };

  const props = {
    beforeUpload: (file) => {
      setSelectedFile(file);
      return false;
    },
    showUploadList: false,
    disabled: file !== null,
  };

  const handleNameBlacklist = (e) => {
    setBlacklistName(e.target.value);
  };

  return (
    <>
      {resultMessage}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          columnGap: "100px",
          backgroundColor: "white",
          paddingLeft: "40px",
          paddingRight: "50px",
          paddingTop: "40px",
          paddingBottom: "100px",
          borderRadius: "25px",
        }}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            rowGap: "10px",
          }}
        >
          <div>
            {" "}
            <Typography.Title level={3}>
              Upload your own Blacklist
            </Typography.Title>
            <Typography.Text>
              {" "}
              You can upload your personal Blacklist here.
            </Typography.Text>
          </div>
          <div>
            Please note that your file must be in .xlsx or .csv format only, or
            you can submit a ZIP file that contains either .xlsx or .csv file.
            The file must contain 4 columns: <br />
            <div
              style={{
                paddingTop: "20px",
              }}
            >
              <div>1. Full Name (First Name & Last Name)</div>
              <div>2. Unique Identifaction Number</div>
              <div>3. Document Number</div>
              <div>4. Expiration date</div>
            </div>
          </div>
          <div>
            <div>Name Your Blacklist</div>
            <Form onFinish={handleUpload}>
              <Form.Item>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "10px",
                    marginBottom: "30px",
                  }}
                >
                  <Input
                    className="blacklist_input"
                    value={blacklistName}
                    onChange={handleNameBlacklist}
                    placeholder=""
                  />

                  <Upload {...props}>
                    <Button
                      disabled={
                        isLoading || file !== null || blacklists.length >= 3
                      }
                      type="primary"
                      icon={<UploadOutlined />}
                    >
                      Select .xlsx, .csv or .zip file
                    </Button>
                  </Upload>
                </div>
                <Input
                  value={
                    blacklists.length >= 3
                      ? "You have reached your limit"
                      : file === null
                      ? "File is not chosen yet"
                      : file.name
                  }
                  disabled
                />
                <Button
                  style={{
                    marginTop: "10px",
                  }}
                  loading={uploading}
                  type="primary"
                  htmlType="submit"
                  disabled={
                    blacklists.length > 3 ||
                    file === null ||
                    blacklistName === ""
                  }
                >
                  Upload
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            borderRadius: "16px",
            backgroundColor: "#F0F2F5",
            rowGap: "10px",
            padding: "30px 24px",
            width: "50%",
          }}
        >
          <Typography.Title level={3}>My Blacklists</Typography.Title>
          <Typography.Text id="blacklist_list" style={{display: 'flex', flexDirection: 'column', rowGap: '8px'}}>
            {isLoading ? (
              <Skeleton />
            ) : blacklists.length > 0 ? 
            
            (
              blacklists.map((blacklist) => {
                return (
                  <div
                    className="blacklist_item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: '16px'
                    }}
                  >
                    <div>{blacklist.list_name}</div>
                    <div>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          onClick={(event) => openModal(blacklist.list_name)}
                          style={{ color: "black", fontSize: "16px" }}
                        />
                      </Tooltip>
                    </div>
                  </div>
                );
              })
            ) : (
              "You don't have any Blacklists yet."
            )}
          </Typography.Text>
          <Typography.Text>
            {blacklists.length >= 3
              ? "You have reached your limit. Please Delete one of your Blacklists to Upload new Blacklist."
              : ""}
          </Typography.Text>
        </div>
        <Modal
          centered
          open={modalOpen}
          onCancel={() => setModalOpen(false)}
          footer={null}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "50px",
              paddingBottom: "50px",
              rowGap: "10px",
            }}
          >
            <Typography.Title level={3}>Are you sure?</Typography.Title>
            <Typography.Text>
              This action cannot be undone. Delete '{modalSelectedList}' blacklist?
            </Typography.Text>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                columnGap: "20px",
              }}
            >
              <Button
                type="primary"
                className="modal_delete_button"
                onClick={() => handleDelete(modalSelectedList)}
              >
                Delete file
              </Button>
              <Button onClick={() => setModalOpen(false)}>Cancel</Button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
